import { isExpEditor } from '../lib/lib'
import Swiper from 'swiper/bundle'

class bookingSeats {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.strip = jQuery(element)

    const swiper = new Swiper(this.strip.find('.swiper')[0], {
      centeredSlides: false,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 8,
        },
        576: {
          slidesPerView: 1.75,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 8,
        },
        992: {
          slidesPerView: 2.5,
          spaceBetween: 8,
        },
      },
      pagination: {
        el: this.strip.find('.swiper-pagination')[0],
        type: 'bullets',
        clickable: true,
      },
    })
  }
}

export default bookingSeats
